import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import {
    RugianoProjectBody,
    RugianoProjectDetails,
    RugianoProjectListItem,
} from "types/api/rugianoProject";

function useRugianoProjectApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllRugianoProject = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<RugianoProjectListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<RugianoProjectListItem>>({
            url: "/rugiano-project",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneRugianoProject = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<RugianoProjectDetails> => {
        return get<PathParamsWithId, undefined, RugianoProjectDetails>({
            url: "/rugiano-project/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createRugianoProject = React.useCallback((body: RugianoProjectBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, RugianoProjectBody, ResponseWithId>({
            url: "/rugiano-project",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateRugianoProject = React.useCallback((pathParams: PathParamsWithId, body: RugianoProjectBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, RugianoProjectBody, null>({
            url: "/rugiano-project/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteRugianoProject = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/rugiano-project/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllRugianoProject,
        getOneRugianoProject,
        createRugianoProject,
        updateRugianoProject,
        deleteRugianoProject
    };
}

export default useRugianoProjectApi;